import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { IconsEnum } from 'src/app/shared/enum/Icons.enum';

@Component({
  selector: 'aoe-informations-presta',
  templateUrl: './informations-presta.component.html',
  styleUrls: ['./informations-presta.component.scss'],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule
  ]
})
export class InformationsPrestaComponent implements OnInit {

  icons = IconsEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
